import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_ENDPOINTS } from "../../../../util/constants";
import {
  createHeadersWithAuth,
  createQueryString,
  requestPromise
} from "../../../../util/request";

export const actionTypes = {
  CallReports: "[Configuration] Call Reports Action",
  CallReportsSuccess: "[Configuration] Call Reports Success Action",
  CallCategories: "[Configuration] Call Categories Action",
  CallCategoriesSuccess: "[Configuration] Call Categories Success Action",
  CallMyAgents: "[Configuration] Call My Agents Action",
  CallMyAgentsSuccess: "[Configuration] Call My Agents Success Action",
  CallSelectedGenericCategory:
    "[Configuration] Call Selected Generic Category Action",
  CallSelectedGenericCategorySuccess:
    "[Configuration] Call Selected Generic Category Success Action",
  CallSelectedGenericReport:
    "[Configuration] Call Selected Generic Report Action",
  CallSelectedGenericReportSuccess:
    "[Configuration] Call Selected Generic Report Success Action",
  CallSelectedGenericAgent:
    "[Configuration] Call Selected Generic Agent Action",
  CallSelectedGenericAgentSuccess:
    "[Configuration] Call Selected Generic Agent Success Action",
  CallSubscriberListByReport:
    "[Configuration] Call Subscriber List By Report Action",
  CallSubscriberListByReportSuccess:
    "[Configuration] Call Subscriber List By Report Success Action",
};

const initialConfigurationState = {
  callReports: null,
  callCategories: null,
  callMyAgents: null,
  callSelectedGenericCategory: null,
  callSelectedGenericReport: null,
  callSelectedGenericAgent: null,
  callSubscriberListByReport: null,
};

export const actions = {
  callReports: (payload) => ({ type: actionTypes.CallReports, payload }),
  callReportsSuccess: (payload) => ({
    type: actionTypes.CallReportsSuccess,
    payload,
  }),

  callCategories: (payload) => ({ type: actionTypes.CallCategories, payload }),
  callCategoriesSuccess: (payload) => ({
    type: actionTypes.CallCategoriesSuccess,
    payload,
  }),

  callMyAgents: (payload) => ({ type: actionTypes.CallMyAgents, payload }),
  callMyAgentsSuccess: (payload) => ({
    type: actionTypes.CallMyAgentsSuccess,
    payload,
  }),

  callSelectedGenericCategory: (payload) => ({
    type: actionTypes.CallSelectedGenericCategory,
    payload,
  }),
  callSelectedGenericCategorySuccess: (payload) => ({
    type: actionTypes.CallSelectedGenericCategorySuccess,
    payload,
  }),

  callSelectedGenericReport: (payload) => ({
    type: actionTypes.CallSelectedGenericReport,
    payload,
  }),
  callSelectedGenericReportSuccess: (payload) => ({
    type: actionTypes.CallSelectedGenericReportSuccess,
    payload,
  }),

  callSelectedGenericAgent: (payload) => ({
    type: actionTypes.CallSelectedGenericAgent,
    payload,
  }),
  callSelectedGenericAgentSuccess: (payload) => ({
    type: actionTypes.CallSelectedGenericAgentSuccess,
    payload,
  }),

  callSubscriberListByReport: (payload) => ({
    type: actionTypes.CallSubscriberListByReport,
    payload,
  }),
  callSubscriberListByReportSuccess: (payload) => ({
    type: actionTypes.CallSubscriberListByReportSuccess,
    payload,
  }),
};

export const getKeyName = () => {
  return process.env.REACT_APP_VERSION + "-module-configuration";
};

export const reducer = persistReducer(
  {
    storage,
    key: getKeyName(),
    whitelist: ["callReports", "callCategories", "callMyAgents"],
  },
  (state = initialConfigurationState, action) => {
    switch (action.type) {
      case actionTypes.CallReportsSuccess:
        return {
          ...state,
          callReports: action.payload,
        };
      case actionTypes.CallCategoriesSuccess:
        return {
          ...state,
          callCategories: action.payload,
        };
      case actionTypes.CallMyAgentsSuccess:
        return {
          ...state,
          callMyAgents: action.payload,
        };
      case actionTypes.CallSelectedGenericCategorySuccess:
        return {
          ...state,
          callSelectedGenericCategory: action.payload,
        };
      case actionTypes.CallSelectedGenericReportSuccess:
        return {
          ...state,
          callSelectedGenericReport: action.payload,
        };
      case actionTypes.CallSelectedGenericAgentSuccess:
        return {
          ...state,
          callSelectedGenericAgent: action.payload,
        };
      case actionTypes.CallSubscriberListByReportSuccess:
        return {
          ...state,
          callSubscriberListByReport: action.payload,
        };
      default:
        return state;
    }
  }
);

export function* postCallReports(action) {
  let requestURL = API_ENDPOINTS.getReports;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callReportsSuccess(response, options.method));
  } catch (error) {}
}
export function* postCallMyAgents(action) {
  let requestURL = API_ENDPOINTS.getReportsAgents;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callMyAgentsSuccess(response, options.method));
  } catch (error) {}
}

export function* postCallCategories(action) {
  let requestURL = API_ENDPOINTS.getReportCategories;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(actions.callCategoriesSuccess(response, options.method));
  } catch (error) {}
}

export function* postSelectedCategory(action) {
  yield put(actions.callSelectedGenericCategorySuccess(action.payload));
}

export function* postSelectedReport(action) {
  yield put(actions.callSelectedGenericReportSuccess(action.payload));
}

export function* postSelectedAgent(action) {
  yield put(actions.callSelectedGenericAgentSuccess(action.payload));
}

export function* postCallSubscriberByReport(action) {
  let requestURL = API_ENDPOINTS.getSubscribedReports;
  const options = {};
  options.headers = createHeadersWithAuth();
  options.method = "GET";
  try {
    const queryString = createQueryString(action.payload);
    requestURL = `${requestURL}?${queryString}`;
    let response = null;
    response = yield call(requestPromise, requestURL, options);
    yield put(
      actions.callSubscriberListByReportSuccess(response, options.method)
    );
  } catch (error) {}
}

export function* saga() {
  yield takeLatest(actionTypes.CallReports, postCallReports);
  yield takeLatest(actionTypes.CallMyAgents, postCallMyAgents);
  yield takeLatest(actionTypes.CallCategories, postCallCategories);
  yield takeLatest(
    actionTypes.CallSelectedGenericCategory,
    postSelectedCategory
  );
  yield takeLatest(actionTypes.CallSelectedGenericReport, postSelectedReport);
  yield takeLatest(actionTypes.CallSelectedGenericAgent, postSelectedAgent);
  yield takeLatest(
    actionTypes.CallSubscriberListByReport,
    postCallSubscriberByReport
  );
}
